import { useLocalStorage } from "@rehooks/local-storage";

import { External } from "components/icons/generated";
import LinkButton from "ds/components/Button/LinkButton";
import Card from "ds/components/Card";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Typography from "ds/components/Typography";
import { AnalyticsPageDashboard } from "hooks/useAnalytics/pages/dashboard";
import { AI_SURVEY_LINK } from "constants/url";

import { ReactComponent as Illustration } from "./illustration.svg";
import styles from "./styles.module.css";

const DashboardOverviewColumnSurvey = () => {
  const [isHidden, setIsHidden] = useLocalStorage("dashboardWidgetAiSurveyHidden", false);

  if (isHidden) {
    return null;
  }

  return (
    <Card
      className={styles.card}
      contentClassName={styles.content}
      contentGap="x-large"
      title="Help us improve Spacelift!"
      headerSuffix={
        <DropdownMenuEllipsis tooltip="Settings" buttonVariant="ghost">
          <DropdownMenuItem onAction={() => setIsHidden(true)}>Hide</DropdownMenuItem>
        </DropdownMenuEllipsis>
      }
    >
      <Illustration />
      <Typography tag="p" variant="p-t7" align="center">
        Tell us how you use AI and Spacelift's AI, and what you would want it to do
      </Typography>
      <LinkButton
        variant="secondary"
        size="medium"
        endIcon={External}
        href={AI_SURVEY_LINK}
        target="_blank"
        rel="noopener noreferrer"
        analyticsPage={AnalyticsPageDashboard.Dashboard}
        analyticsTitle="Dashboard - AI Survey Clicked"
      >
        Take the survey
      </LinkButton>
    </Card>
  );
};

export default DashboardOverviewColumnSurvey;
